import React, { useEffect, useState } from "react";
import api from "../api/api";
import Header from "../components/header";
import "../styles/preview.css";

const alphabet = "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЮЯ".split("");

const Preview = () => {
  const [search, setSearch] = useState("");
  const [words, setWords] = useState([]);

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" | "error"

  const [newWord, setNewWord] = useState("");
  const [newDefinition, setNewDefinition] = useState("");

  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("0");

  const [showWords, setShowWords] = useState(true); // true = show word list

    useEffect(() => {
      localStorage.removeItem("regions");
      loadRegions();
    }, []);

    const loadRegions = async () => {
      try {
        const res = await api.get("/dictionary/getregions");
        setRegions(res.data || []);
      } catch {
        console.error("Грешка при зареждане на региони.");
      } 
    };
  /* ===============================
     SEARCH
     =============================== */
  const searchWords = async () => {
    setShowWords(!showWords);
    if (!search) {
      setWords([]);
      setMessage("Въведете дума за търсене.");
      return;
    }
    try {
      const res = await api.get("/dictionary/search", {
        params: { term: search,
        region: selectedRegion }
      });
      setWords(res.data || []);
      setMessage(res.data?.length === 0 ? "Няма резултати" : "");
    } catch {
      setMessage("❌ Грешка при търсене");
      setMessageType("error"); 
    } 
  };
  /* ===============================
     FILTER BY LETTER
     =============================== */
  const filterByLetter = async (letter) => {
    setSearch("");
    setShowWords(!showWords);
    try {
      const res = await api.get(`/dictionary/searchbyletter/${letter}`, {
        params: { region: selectedRegion }
      });
      setWords(res.data || []);
      setMessage(res.data?.length === 0 ? "Няма резултати" : "");
    } catch {
      setMessage("❌ Грешка при търсене");
      setMessageType("error"); 
    } 
  };
  /* ===============================
     CLEAR
     =============================== */
  const clearAll = () => {
    setSearch("");
    setSelectedRegion("");
    setWords([]);
    setMessage("");
    setShowWords(!showWords);
  };
  /* ===============================
     ADD TEMP WORD
     =============================== */
  const addWord = async () => {
    if (!newWord) {
      setMessage("Въведете дума");
      setMessageType("error"); 
      return;
    }
    if (!newDefinition) {
      setMessage("Въведете определение");
      setMessageType("error"); 
      return;
    }
    if (selectedRegion === "0") {
      setMessage("Изберете регион");
      setMessageType("error"); 
      return;
    }
    try {
      await api.post("/dictionary/addtempword", {
        term: newWord,
        definition: newDefinition,
        regionID: selectedRegion
      });
      setNewWord("");
      setNewDefinition("");
      setWords([]);
      setMessage("Думата е изпратена за одобрение");
      setMessageType("success");

      setSelectedRegion("0");

      setTimeout(() => {
        setMessage("");
      }, 5000);
    } catch {
      setMessage("❌ Грешка при добавяне");
      setMessageType("error"); 
    }
  };


  return (
    <div className="page-background">
      <div className="preview-container">
        <h1 className="header-text"><b>ПЕСНОСЛОВНИК</b></h1>
        <Header />

        <p>
          <select
            style={{ maxWidth: "50%" }}
            value={selectedRegion}
            onChange={(e) => {
              const value = e.target.value;

              setSelectedRegion(value === "" ? "0" : Number(value));

              setWords([]);
              setMessage("");
              setSearch("");
            }}
          >
            <option value="0">-- Всички региони --</option>

            {regions.map(r => (
              <option key={r.id} value={r.id}>
                {r.name}
              </option>
            ))}
          </select>
        </p>
        {/* Alphabet */}
        <div className="alphabet-bar">
          {alphabet.map(letter => (
            <button
              key={letter}
              className="alphabet-btn"
              onClick={() => filterByLetter(letter)}
            >
              {letter}
            </button>
          ))}
        </div>

        {/* Search + Region */}        
        <div className="search-bar">          
          <input
            type="text"
            placeholder="Търсене на дума..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setMessage("");
            }}
          />         

          <div className="search-buttons">
            <button onClick={searchWords}>Търсене</button>
            <button onClick={clearAll}>Изчистване</button>
            <button onClick={() => setShowWords(!showWords)}>{showWords ? "Добави дума" : "Покажи думите"}</button>
            </div>
          </div>

        {message && <p className={`message ${messageType}`}>{message}</p>}

        {/* Word List */}
        {showWords && (
        <div className="word-list-container">
          <ul className="word-list">
          {words.map(w => (
            <li key={w.id} className="word-card">
              <strong><u>{w.term}</u></strong>
              <p><i>Регион:</i> {w.region}</p>
              <p><i>Определение:</i> {w.definition}</p>
            </li>
            ))}
          </ul>
        </div>
        )}
        {/* Add temp word */}
        {!showWords && (
          <div className="add-word">
          <h3>Добави дума</h3>
          <input
            type="text"
            placeholder="Дума"
            value={newWord}
            onChange={(e) => setNewWord(e.target.value)}
          />
          <textarea
            rows={4}
            placeholder="Определение"
            value={newDefinition}
            onChange={(e) => setNewDefinition(e.target.value)}
          />
          <button onClick={addWord}>Запис</button>
        </div>
        )}
      </div>
    </div>
  );
};

export default Preview;
